// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e9vR9nnSYA8bB_SZwZkk {
	display: flex;
	flex-direction: column;
}

.e9vR9nnSYA8bB_SZwZkk > *:not(:last-child) {
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.2);
		margin-bottom: 8px;
	}

.m6qVLfPQ51Yng708XmLh {
	align-items: center;
	display: flex;
	font-size: 16px;
	gap: 5px;
	letter-spacing: -0.08em;
	line-height: 24px;
}

.UIyFTbgt5_nwc4_QRzF1 {
	color: rgba(0, 0, 0, 0.2);
}

.lGN_1IdznFQVJCZPKdsw {
	min-width: 70px;
}

.BX3RfycMRXbMBdKCKkG6 {
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.vw4vmD1YJwrNCxhBWlhB {
	max-width: 100px;
	width: 100%;
}

._4Jcq0NzakFWRJGRSMcD {
	color: var(--green);
}
`, "",{"version":3,"sources":["webpack://./src/pages/VESISPage/AboutLock/LockInfo.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;AAMvB;;AAJC;EACC,6CAA6C;EAC7C,kBAAkB;CACnB;;AAGD;CACC,mBAAmB;CACnB,aAAa;CACb,eAAe;CACf,QAAQ;CACR,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& > *:not(:last-child) {\n\t\tborder-bottom: 0.5px solid rgba(0, 0, 0, 0.2);\n\t\tmargin-bottom: 8px;\n\t}\n}\n\n.row {\n\talign-items: center;\n\tdisplay: flex;\n\tfont-size: 16px;\n\tgap: 5px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n}\n\n.title {\n\tcolor: rgba(0, 0, 0, 0.2);\n}\n\n.column {\n\tmin-width: 70px;\n}\n\n.value {\n\tflex: 1;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.expires {\n\tmax-width: 100px;\n\twidth: 100%;\n}\n\n.unlock {\n\tcolor: var(--green);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `e9vR9nnSYA8bB_SZwZkk`,
	"row": `m6qVLfPQ51Yng708XmLh`,
	"title": `UIyFTbgt5_nwc4_QRzF1`,
	"column": `lGN_1IdznFQVJCZPKdsw`,
	"value": `BX3RfycMRXbMBdKCKkG6`,
	"expires": `vw4vmD1YJwrNCxhBWlhB`,
	"unlock": `_4Jcq0NzakFWRJGRSMcD`
};
export default ___CSS_LOADER_EXPORT___;
